export default "__VITE_ASSET__3144b652__"